module.exports = __webpack_public_path__ + "static/media/service_s3.3469e132.png";